export default __webpack_public_path__ + "static/media/Icon feather-phone.2ad0306c.svg";